import { render, staticRenderFns } from "./intro.vue?vue&type=template&id=f1079350"
import script from "./intro.vue?vue&type=script&lang=ts"
export * from "./intro.vue?vue&type=script&lang=ts"
import style0 from "./intro.vue?vue&type=style&index=0&id=f1079350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionTitle.vue').default,IxSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionText.vue').default,IxButtonAction: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Action.vue').default,IxSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Section.vue').default,IxBtnBack: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/Back.vue').default,EsgChipWithImplementationStatus: require('/home/runner/work/assessment-service/assessment-service/frontend/components/esg/ChipWithImplementationStatus.vue').default})
